// extracted by mini-css-extract-plugin
export var fullGrid = "_2a-3";
export var pdpPreviewContainer = "_2a-1";
export var previewContainer = "_2a-0";
export var togglePreviewContainer = "_2a-2";